export default "__VITE_ASSET__DTx6D1LH__"